import styled, { css } from 'styled-components'

import { Grid } from '../../components/Base/Base'
import { Handler } from '../../helpers/typeHelper'
import { bgGray, informationL1 } from '../../theme/colors'

export function IssueListGrid({
  children,
  className,
  isItem,
  isSmall,
  onClick,
}: {
  children: React.ReactNode
  className?: string
  isItem?: boolean
  isSmall?: boolean
  onClick?: Handler
}) {
  const columns = '270px 150px 200px'

  if (isItem) {
    return (
      <HoveredGrid columns={columns} gap="15px" className={className} onClick={onClick} $isSmall={isSmall}>
        {children}
      </HoveredGrid>
    )
  }

  return (
    <Grid columns={columns} gap="15px" className={className}>
      {children}
    </Grid>
  )
}

const HoveredGrid = styled(Grid)<{ onClick?: Handler; $isSmall?: boolean }>`
  position: relative;
  margin: 0 -24px;
  padding: 25px 24px 17px;

  ${(p) =>
    p.onClick &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${informationL1};

        .actions > * {
          visibility: visible;
        }
      }
    `}

  ${(p) =>
    p.$isSmall &&
    css`
      padding-top: 15px;
      padding-bottom: 5px;
    `}

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    border-top: 2px solid ${bgGray};
  }
`
